import React, { Component } from "react";

export class DetailAdvance extends Component {
    render() {
        return <div id="wrappDetailAdvance" className="detail-process">

            <div className="wrapp-interna-process-banner">
                <img src={require('../../images/avanzado.jpg')} />
            </div>

            <h2 class="text-center d-inline-block margin-top-40">Entrenamiento avanzado</h2>
            <div className="text-center d-inline-block">
                <span>40 horas</span><span>|</span><span>$850.000</span>
            </div>
            <p>
                Pon tu pasión a trabajar...Ya la espera ha terminado...
            </p>

            <p>
                El Taller Avanzado es trabajar directamente con todo lo descubierto en el Taller Básico. Son cuatro días completos de trabajo profundo y comprometido para descubrir el Ser, tu esencia, tus características de liderazgo, tu potencial, tu fuerza y tu compromiso. Son cuatro días de adrenalina y desafíos, trabajando en la experiencia más impactante y motivadora que hayas vivido. La posibilidad que te ofrece el participar en el Taller Avanzado, es soltar definitivamente el pasado y utilizar tu experiencia para crecer y crear desde tu Ser el diseño de una vida exitosa. La oportunidad de vivir desde tu esencia y tus posibilidades desde ahora en adelante.
            </p>

            <p>
                Verás el impacto de este taller en las siguientes áreas:
            </p>

            <ul>
                <li>
                    ¿Cómo sería una vida que valga la pena SER vivida?
                </li>
                <li>
                    Transformarás tu capacidad para obtener logros
                </li>
                <li>
                    Vivir en servicio y contribución
                </li>
                <li>
                    Impacto e intimidad en tus relaciones más importantes
                </li>
                <li>
                    Nueva capacidad para escuchar y solucionar conflictos
                </li>
                <li>
                    Relacionarte con el mundo como un agente responsable y de causa- y no de efecto
                </li>
                <li>
                    La integridad
                </li>
                <li>
                    Logros extraordinarios en tu vida
                </li>
                <li>
                    Trabajarás profundamente tu imagen
                </li>
                <li>
                    La importancia de convivir y ser parte de un grupo
                </li>
                <li>
                    Ser fuente de todo lo que ocurre en tu vida
                </li>
                <li>
                    Tomar riesgos importantes en las áreas que están estancadas en tu vida
                </li>
                <li>
                    Descubrir una parte de ti que no eras consciente
                </li>
                <li>
                    Honestidad emocional y libertad para escoger
                </li>
                <li>
                    El valor de ser y recibir incondicionalidad
                </li>
            </ul>
            <h2 class="text-center d-inline-block margin-top-40">Itinerario</h2>
        </div>
    }
}